import { render } from "./HighlightTab.vue?vue&type=template&id=354b5ace&ts=true"
import script from "./HighlightTab.vue?vue&type=script&lang=ts"
export * from "./HighlightTab.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__